export const ruRu = (__LOCALE_RU__ ? ({
  sources: {
    sync: {
      synced: 'Параметры синхронизированы',
      unsynced: 'Параметры не синхронизированы',
    },
    analytics_types: {
      facestream: 'Лица и тела',
    },
    stream_settings: {
      fields: {
        timestamp_source: 'Формат отсчёта времени',
        start_time: 'Начальное время',
        rotation: 'Угол поворота камеры',
        attempt_count: 'Количество попыток',
        delay: 'Задержка автоперезагрузки (в секундах)',
      },
      timestamp_options: {
        auto: 'Авто',
        pts: 'PTS',
        dts: 'DTS',
        server: 'Время сервера',
        frame_rate: 'По частоте кадров',
      },
      tooltips: {
        timestamp_source: 'Источник меток времени видео',
        start_time: 'Начальное время видео, доступно при формате отсчёта времени PTS',
        rotation: 'Угол поворота камеры в градусах',
        attempt_count: 'Максимальное количество попыток автоперезапуска',
        delay: 'Пауза между попытками автоперезапуска',
      },
    },
    geoposition: {
      title: 'Геопозиция',
      set_geoposition: 'Установить геопозицию',
      edit_geoposition: 'Изменить геопозицию',
      longitude: 'Долгота',
      latitude: 'Широта',
      fullscreen: 'Полноэкранный режим',
      exit_fullscreen: 'Выйти из полноэкранного режима',
      fields: {
        city: 'Город',
        area: 'Область',
        district: 'Район',
        street: 'Улица',
        house_number: 'Дом',
        longitude_input: 'Долгота (в градусах)',
        latitude_input: 'Широта (в градусах)',
      },
      validation: {
        required: 'Обязательное поле',
        number: 'Введите число',
        max_length: 'Максимум 36 символов',
      },
      on_save: 'Установить',
      on_cancel: 'Отмена',
    },

  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  sources: {
    sync: {
      synced: 'Parameters are synced',
      unsynced: 'Parameters are not synced',
    },
    analytics_types: {
      facestream: 'Faces and bodies',
    },
    stream_settings: {
      fields: {
        timestamp_source: 'Timestamp source',
        start_time: 'Start time',
        rotation: 'Camera rotation angle',
        attempt_count: 'Attempt count',
        delay: 'Autorestart delay (in seconds)',
      },
      timestamp_options: {
        auto: 'Auto',
        pts: 'PTS',
        dts: 'DTS',
        server: 'Server time',
        frame_rate: 'By frame rate',
      },
      tooltips: {
        timestamp_source: 'Video timestamp source',
        start_time: 'Video start time, available with PTS timestamp source',
        rotation: 'Camera rotation angle in degrees',
        attempt_count: 'Maximum number of autorestart attempts',
        delay: 'Delay between autorestart attempts',
      },
    },
    geoposition: {
      title: 'Geolocation',
      set_geoposition: 'Set geolocation',
      edit_geoposition: 'Edit geolocation',
      longitude: 'Longitude',
      latitude: 'Latitude',
      fullscreen: 'Fullscreen mode',
      exit_fullscreen: 'Exit fullscreen mode',
      fields: {
        city: 'City',
        area: 'Region',
        district: 'District',
        street: 'Street',
        house_number: 'House number',
        longitude_input: 'Longitude in degrees',
        latitude_input: 'Latitude in degrees',
      },
      validation: {
        required: 'Required field',
        number: 'Enter a number',
        max_length: 'Maximum 36 characters',
      },
      on_save: 'Set',
      on_cancel: 'Cancel',
    },

  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  sources: {
    sync: {
      synced: 'Parámetros sincronizados',
      unsynced: 'Parámetros no sincronizados',
    },
    analytics_types: {
      facestream: 'Caras y cuerpos',
    },
    stream_settings: {
      fields: {
        timestamp_source: 'Formato de marcas de tiempo',
        start_time: 'Hora inicial',
        rotation: 'Ángulo de rotación de la cámara',
        attempt_count: 'Número de intentos',
        delay: 'Retardo de autorreinicio (en segundos)',
      },
      timestamp_options: {
        auto: 'Auto',
        pts: 'PTS',
        dts: 'DTS',
        server: 'Hora del servidor',
        frame_rate: 'Por frecuencia de fotogramas',
      },
      tooltips: {
        timestamp_source: 'Fuente de marcas de tiempo del video',
        start_time: 'Hora inicial del video, disponible con PTS',
        rotation: 'Ángulo de rotación de la cámara en grados',
        attempt_count: 'Número máximo de intentos de autorreinicio',
        delay: 'Pausa entre intentos de autorreinicio',
      },
    },
    geoposition: {
      title: 'Geolocalización',
      set_geoposition: 'Establecer geolocalización',
      edit_geoposition: 'Cambiar geolocalización',
      longitude: 'Longitud',
      latitude: 'Latitud',
      fullscreen: 'Modo de pantalla completa',
      exit_fullscreen: 'Salir del modo de pantalla completa',
      fields: {
        city: 'Ciudad',
        area: 'Región',
        district: 'Distrito',
        street: 'Calle',
        house_number: 'Número de casa',
        longitude_input: 'Longitud en grados',
        latitude_input: 'Latitud en grados',
      },
      validation: {
        required: 'Campo obligatorio',
        number: 'Introduce un número',
        max_length: 'Máximo 36 caracteres',
      },
      on_save: 'Establecer',
      on_cancel: 'Cancelar',
    },

  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  sources: {
    sync: {
      synced: 'Parâmetros sincronizados',
      unsynced: 'Parâmetros não sincronizados',
    },
    analytics_types: {
      facestream: 'Rostos e corpos',
    },
    stream_settings: {
      fields: {
        timestamp_source: 'Formato das marcas de tempo',
        start_time: 'Hora inicial',
        rotation: 'Ângulo de rotação da câmera',
        attempt_count: 'Número de tentativas',
        delay: 'Atraso do autorreinício (em segundos)',
      },
      timestamp_options: {
        auto: 'Auto',
        pts: 'PTS',
        dts: 'DTS',
        server: 'Hora do servidor',
        frame_rate: 'Por taxa de quadros',
      },
      tooltips: {
        timestamp_source: 'Fonte das marcas de tempo do vídeo',
        start_time: 'Hora inicial do vídeo, disponível com PTS',
        rotation: 'Ângulo de rotação da câmera em graus',
        attempt_count: 'Número máximo de tentativas de autorreinício',
        delay: 'Pausa entre tentativas de autorreinício',
      },
    },
    geoposition: {
      title: 'Geolocalização',
      set_geoposition: 'Definir geolocalização',
      edit_geoposition: 'Alterar geolocalização',
      longitude: 'Longitude',
      latitude: 'Latitude',
      fullscreen: 'Modo de tela cheia',
      exit_fullscreen: 'Sair do modo de tela cheia',
      fields: {
        city: 'Cidade',
        area: 'Região',
        district: 'Distrito',
        street: 'Rua',
        house_number: 'Número da casa',
        longitude_input: 'Longitude em graus',
        latitude_input: 'Latitude em graus',
      },
      validation: {
        required: 'Campo obrigatório',
        number: 'Digite um número',
        max_length: 'Máximo de 36 caracteres',
      },
      on_save: 'Definir',
      on_cancel: 'Cancelar',
    },

  },
}) : {}) as Record<string, unknown>;
